// src/views/kiddo-games/letters/components/LetterSlot.tsx
import React, { FC, memo } from 'react';

interface LetterSlotProps {
  letter: string;
  isActive: boolean;
  isSpace?: boolean;
}

export const LetterSlot: FC<LetterSlotProps> = memo(({ letter, isActive, isSpace = false }) => {
  const isFilled = letter || isSpace;

  return (
    <div
      className={`letter-slot ${isActive ? 'letter-slot--active' : ''} ${
        isFilled ? 'letter-slot--filled' : ''
      } ${isSpace ? 'letter-slot--space' : ''}`}
    >
      {isSpace ? '' : letter || '_'}
    </div>
  );
});
